export default "__VITE_ASSET__p$kuTDLH__"